<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <magazine-recommend-component :magazineKey="magazineKey"></magazine-recommend-component>
                    <div class="mt15 text_center">
                        <el-button @click="submitForm()" type="primary">저장</el-button>
                    </div>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
    </div>
</template>

<script>
import MagazineRecommendComponent from "@/components/magazine/MagazineRecommendComponent";
import EventBus from "@/mixins/event-bus.js"
import VuxAlert from '@/mixins/alertMixins';
import {mapState} from "vuex";

export default {
    name: 'ThemeRecommend',
    components: {
        MagazineRecommendComponent,
    },
    mixins: [VuxAlert],
    data() {
        return {
            recommendKey: this.$route.params.p_idx,
            magazineKey: this.$route.params.p_idx,
            title: this.$route.meta.title,
            selectIdx: 0,
            createItemList: [],
            selectItems: [],
            themeDetail: {},
        }
    },
    created(){
        this.settingData();
    },
    mounted() {
    },
    beforeDestroy() {
        this.$store.dispatch( 'common/setData', {data: {}} );
    },
    computed: {
        ...mapState({
            data: state => state.common.data,
        }),
    },
    methods: {
        setRow(rows) {
            this.selectRow = rows;
        },
        setData(key, value) {
            this[key] = value;
        },
        settingData() {
            let settingData = {
                selectItems: [],
                deleteItemList: [],
                createItemList: [],
            }
            this.$store.dispatch( 'common/setData', {data: settingData} );
        },
        setItem(theme) {
            this['theme'+this.selectIdx][theme.p_idx] = theme;
            this.selectItems = Object.keys(this['theme'+this.selectIdx]);
            this.createItemList[this.selectIdx].push(theme.p_idx);
            this.$forceUpdate();
        },
        submitForm() {
            EventBus.$emit('saveRecommendMagazine')
        },
    },
    watch: {
    },
}
</script>
